"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = capitalize;
// REMOVE ONCE: https://github.com/storybookjs/storybook/issues/13322 is closed
// FIXME [https://github.com/storybookjs/storybook/issues/13322]: REMOVE DEPENDENCY on prettier directly once storybook issue is fixed
function capitalize(text) {
  return text.charAt(0).toUpperCase() + text.slice(1);
}
